export const endpointPath = '/users'
export interface UserDto {
  selectedSiteId: number;
  isAdmin: boolean;
}
